import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callContractorPortalSecureApi } from '../api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import {
  ContractorPortalFetchDriver,
  ContractorPortalUploadBankInformation,
} from 'src/constants/actionTypes'
import { PaymentMethodTypeEnum, RecipientTypeEnum } from 'src/interfaces/paymentMethod'

interface ContractorPortalBankInformationRequest {
  routingNumber: string
  accountNumber: string
  accountType: string
  hasBusinessEntity: boolean
  token?: string | null
}

function* contractorPortalUploadBankInformation(
  action: AsyncAction<ContractorPortalBankInformationRequest>,
) {
  const { routingNumber, accountNumber, accountType, hasBusinessEntity, token } = action.payload

  try {
    yield call(callContractorPortalSecureApi, Endpoints.FetchPaymentMethod, {
      method: 'POST',
      query: token ? { token } : undefined,
      body: {
        paymentMethodType: PaymentMethodTypeEnum.BankAccount,
        bankAccountDetails: {
          recipientType: hasBusinessEntity
            ? RecipientTypeEnum.Business
            : RecipientTypeEnum.Individual,
          routingNumber,
          accountNumber,
          accountType,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(ContractorPortalUploadBankInformation.success())

    yield put(ContractorPortalFetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to upload bank information'

    yield put(ContractorPortalUploadBankInformation.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* contractorPortalBankInformationSaga() {
  yield takeLatest(
    ContractorPortalUploadBankInformation.type.REQUEST,
    contractorPortalUploadBankInformation,
  )
}
